module.exports = __webpack_public_path__ + "OpenSans-LightItalic.8424d63bf351cde78464.eot";


//////////////////
// WEBPACK FOOTER
// C:/Users/jerd_/Documents/e-payment-public/e-payment-frontend/src/assets/customfonts/OpenSans-LightItalic.eot
// module id = ../../../../../src/assets/customfonts/OpenSans-LightItalic.eot
// module chunks = styles